﻿import Rest from '@/rest'

class CacheService {
    async GetUsers() {
        return await Rest.Get(`/api/cache/getusers`);
    }
    async GetSettings() {
        return await Rest.Get(`/api/cache/getsettings`);
    }
    async GetUserSettings() {
        return await Rest.Get(`/api/cache/getusersettings`);
    }
    async View(key) {
        window.open(`/api/cache/view/${key}`);
    }
    async Download(key) {
        window.open(`/api/cache/download/${key}`);
    }
    async Send(key, msg) {
        return await Rest.Post(`/api/cache/send/${key}`, msg);
    }
}

export default new CacheService();